import React from 'react';
const Commission16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "10",
        height: "10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M6.365 4.007l-.685-.638C5.01 2.172 6.488.581 8.65 1.2c.115.033.138.183.042.254-.204.15-.446.451-.475 1.043-.058 1.19-.886 2.084-1.852 1.51zM5.757 4.33c.365.368.38 1.165.035 1.508-1.198.945-3.948 3.106-3.946 3.105l-.002.001c-.142.068-.367 0-.543-.175-.167-.167-.236-.38-.184-.522 0 0 2.345-2.97 3.133-3.96.345-.343 1.142-.323 1.507.044z"
    }));
Commission16.displayName = 'Commission16';
export default Commission16;

//# sourceMappingURL=16x16.js.map